// extracted by mini-css-extract-plugin
export var hidden = "_ot-1";
export var visible = "_ot-0";